import { render, staticRenderFns } from "./AwlSidenav.vue?vue&type=template&id=6c0fb023&"
import script from "./AwlSidenav.vue?vue&type=script&lang=js&"
export * from "./AwlSidenav.vue?vue&type=script&lang=js&"
import style0 from "./AwlSidenav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports